import { render, staticRenderFns } from "./_ProductNameColumn.vue?vue&type=template&id=3d9cf74a"
import script from "./_ProductNameColumn.vue?vue&type=script&lang=js"
export * from "./_ProductNameColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports